import { FaUser, FaUsers } from "react-icons/fa";
import { PiChartLineUpBold } from "react-icons/pi";
import axios from "axios";
import { useState, useEffect } from "react";
import FinanceDashboard from "./FinanceDashBoard";
import ThemeSelector from "./ThemeSelector";

function Dashboard() {
  const [data, setData] = useState();
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.get(`${baseURL}/getDashboardCount`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        console.log("Success");
        setData(response.data);
        console.log("Hi");
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
    

      <div className="p-4  sm:ml-0 md:ml-28 lg:ml-64 min-h-screen overflow-y-auto">
      <div className="flex justify-end mb-4">
    <ThemeSelector />
  </div>
        <div className="p-4">
          {/* Responsive Grid Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-4">
            {/* Customers Card */}
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
              <div className="grid grid-cols-3 items-center">
                <div>
                  <FaUsers className="text-amber-400" size={50} />
                </div>
                <div className="col-span-2">
                  <span className="block text-xl font-semibold text-gray-900 dark:text-white">
                    Customers
                  </span>
                  <div className="text-xl text-gray-900 mt-2 md:pl-6 ">
                    {data?.customer_count}
                  </div>
                </div>
              </div>
            </div>

            {/* Collection Agent Card */}
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
              <div className="grid grid-cols-3 items-center">
                <div>
                  <FaUser className="text-amber-400" size={50} />
                </div>
                <div className="col-span-2">
                  <span className="block text-xl font-semibold text-gray-900 dark:text-white">
                    Collection Agent
                  </span>
                  <div className="text-xl text-gray-900 mt-2  md:text-center ">
                    {data?.admin_count}
                  </div>
                </div>
              </div>
            </div>

            {/* Loan Card */}
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 md:col-span-2 lg:col-span-1">
              <div className="grid grid-cols-3 items-center">
                <div>
                  <PiChartLineUpBold className="text-amber-400" size={50} />
                </div>
                <div className="col-span-2">
                  <span className="block text-xl font-semibold text-gray-900 dark:text-white">
                    Loan
                  </span>
                  <div className="text-xl text-gray-900 mt-2 ">
                    {data?.loan_count}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* FinanceDashboard Component */}
        <FinanceDashboard />
      </div>
  

      {/* Optional Extra Section */}
      <div className="p-4 sm:ml-0 md:ml-28 lg:ml-64 -mt-9">
        <div className="p-4 rounded-lg shadow bg-white dark:border-gray-700 overflow-x-auto">
          {/* Placeholder for additional content */}
        </div>
      </div>
    </>
  );
}

export default Dashboard;
